
(() => {
  'use strict';

  if (window.__lilaPopupFlow) return;
  window.__lilaPopupFlow = true;

  // =====================================================
  // INTERRUPTOR GENERAL
  // 0 = MODO NORMAL
  // 1 = CAMPAÑA CAPA GRATIS
  // =====================================================

  const MODO_CAMPANA = 0;
  const mode = MODO_CAMPANA;

  window.LILA_MODO_CAMPANA = MODO_CAMPANA;

  // =====================================================
  // BARRA DE PROGRESO DE LA CAPA
  // =====================================================

  function actualizarBarraCapa() {
    const debeOcultarse = MODO_CAMPANA !== 1;

    document.querySelectorAll('.capa-regalo-progress').forEach(el => {
      if (el.hidden !== debeOcultarse) {
        el.hidden = debeOcultarse;
      }
    });
  }

  actualizarBarraCapa();

  document.addEventListener('cart:change', actualizarBarraCapa);

  // Shopify Impact puede reconstruir el carrito.
  // Observamos cambios en el DOM para actualizar la barra.

  const observerCapa = new MutationObserver(actualizarBarraCapa);

  function iniciarObservadorCapa() {
    if (!document.body) return;

    observerCapa.observe(document.body, {
      childList: true,
      subtree: true
    });

    actualizarBarraCapa();
  }

  if (document.body) {
    iniciarObservadorCapa();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      iniciarObservadorCapa,
      { once: true }
    );
  }

  // =====================================================
  // POPUP PRINCIPAL
  // =====================================================

  const root = document.getElementById('lila-popup-flow');

  if (!root) return;

  root.classList.toggle('is-campaign', mode === 1);

  const lang = (
    document.documentElement.lang ||
    window.Shopify?.locale ||
    'es'
  ).toLowerCase().startsWith('en') ? 'en' : 'es';

  // =====================================================
  // TRADUCCIONES
  // =====================================================

  const t = {
    es: {
      added: 'Producto añadido correctamente a la cesta. 1/2',
      recommend: 'TE RECOMENDAMOS',
      'add-accessory': 'AÑADIR + ENVÍO GRATIS',
      'all-accessories': 'VER TODA LA COLECCIÓN DE ACCESORIOS →',
      continue: 'SEGUIR COMPRANDO',
      'go-cart': 'IR A LA CESTA',
      'shop-confident': 'COMPRA TRANQUILA',
      'protect-title': 'PROTEGE TU ENVÍO',
      'protect-description': 'Cuando compras para una ocasión especial, que todo llegue bien y a tiempo importa más que nunca. Añade protección a tu pedido.',
      recommended: 'RECOMENDADO',
      plus: 'Protección Plus',
      benefit1: '✓ Prioridad ante cualquier incidencia con tu envío',
      benefit2: '✓ Devoluciones ampliadas a 30 días',
      benefit3: '✓ Doble revisión de calidad antes del envío',
      benefit4: '✓ Revisión personalizada de tu look',
      'add-plus': 'AÑADIR PROTECCIÓN PLUS',
      basic: 'Protección de Envío',
      'basic-description': 'Si surge una incidencia con tu envío, la gestionamos de forma prioritaria y anticipamos el reenvío siempre que sea posible.',
      'add-basic': 'AÑADIR PROTECCIÓN',
      skip: 'Continuar sin protección',

      normalKicker: 'DESBLOQUEA TU',
      normalTitle: 'ENVÍO<br>GRATIS',
      normalDesc: 'Añade un accesorio a tu pedido y consigue <strong>envío estándar gratis.</strong>',

      giftKicker: 'UN REGALO PARA TI · SOLO 48 HORAS',
      giftTitle: 'CAPA<br>GRATIS',
      giftDesc: '¡Enhorabuena! Has desbloqueado una <strong>Capa Gasa de regalo.</strong> Elige tu color favorito.',
      giftAction: 'ELEGIR MI CAPA GRATIS →',

      giftInCartKicker: 'TU REGALO YA ESTÁ EN LA CESTA',
      giftInCartTitle: '¡TODO<br>LISTO!',
      giftInCartDesc: 'Tu Capa Gasa está en la cesta. Comprueba que el descuento se aplique antes de finalizar.',
      giftInCartAction: 'VER MI CESTA →',

      giftPendingKicker: 'TU CAPA YA ESTÁ EN LA CESTA',
      giftPendingTitle: 'REVISA<br>TU REGALO',
      giftPendingDesc: 'La capa está añadida, pero todavía no podemos confirmar que sea gratis. Revisa las condiciones y el descuento en la cesta.',

      giftNotYetKicker: 'TE FALTA MUY POCO',
      giftNotYetTitle: 'CAPA<br>GRATIS',
      giftNotYetDesc: 'Con una compra de 100 € en otras prendas podrás conseguir tu Capa Gasa gratis. Sigue comprando para desbloquearla.'
    },

    en: {
      added: 'Product successfully added to your bag. 1/2',
      recommend: 'WE RECOMMEND',
      'add-accessory': 'ADD + FREE SHIPPING',
      'all-accessories': 'SHOP ALL ACCESSORIES →',
      continue: 'CONTINUE SHOPPING',
      'go-cart': 'GO TO BAG',
      'shop-confident': 'SHOP WITH CONFIDENCE',
      'protect-title': 'PROTECT YOUR DELIVERY',
      'protect-description': 'When shopping for a special occasion, receiving everything safely and on time matters more than ever. Add protection to your order.',
      recommended: 'RECOMMENDED',
      plus: 'Plus Protection',
      benefit1: '✓ Priority assistance with shipping issues',
      benefit2: '✓ Extended returns up to 30 days',
      benefit3: '✓ Double quality check before dispatch',
      benefit4: '✓ Personalised outfit review',
      'add-plus': 'ADD PLUS PROTECTION',
      basic: 'Shipping Protection',
      'basic-description': 'If there is a shipping issue, we handle it as a priority and arrange an early replacement whenever possible.',
      'add-basic': 'ADD PROTECTION',
      skip: 'Continue without protection',

      normalKicker: 'UNLOCK YOUR',
      normalTitle: 'FREE<br>SHIPPING',
      normalDesc: 'Add an accessory to your order and enjoy <strong>free standard shipping.</strong>',

      giftKicker: 'A GIFT FOR YOU · 48 HOURS ONLY',
      giftTitle: 'FREE<br>CAPE',
      giftDesc: 'Congratulations! You have unlocked a <strong>free chiffon cape.</strong> Choose your favourite colour.',
      giftAction: 'CHOOSE MY FREE CAPE →',

      giftInCartKicker: 'YOUR GIFT IS IN YOUR BAG',
      giftInCartTitle: 'ALL<br>SET!',
      giftInCartDesc: 'Your cape is in your bag. Please check that the discount is applied before checkout.',
      giftInCartAction: 'VIEW MY BAG →',

      giftPendingKicker: 'YOUR CAPE IS IN YOUR BAG',
      giftPendingTitle: 'CHECK<br>YOUR GIFT',
      giftPendingDesc: 'Your cape is in the bag, but we cannot yet confirm that it is free. Please check the promotion conditions and discount.',

      giftNotYetKicker: 'YOU ARE ALMOST THERE',
      giftNotYetTitle: 'FREE<br>CAPE',
      giftNotYetDesc: 'Spend €100 on other items to unlock your free chiffon cape. Keep shopping to qualify.'
    }
  }[lang];

  // =====================================================
  // ELEMENTOS DEL POPUP
  // =====================================================

  root.querySelectorAll('[data-lpf-text]').forEach(el => {
    el.textContent = t[el.dataset.lpfText] || el.textContent;
  });

  root.querySelector('.lpf-x').setAttribute(
    'aria-label',
    lang === 'en' ? 'Close' : 'Cerrar'
  );

  const panel = root.querySelector('.lpf-panel');
  const first = root.querySelector('#lpf-first');
  const protection = root.querySelector('#lpf-protection');
  const kicker = root.querySelector('#lpf-kicker');
  const title = root.querySelector('#lpf-title');
  const desc = root.querySelector('#lpf-description');
  const normalProducts = root.querySelector('#lpf-normal-products');
  const campaignProduct = root.querySelector('#lpf-campaign-product');
  const action = root.querySelector('#lpf-campaign-action');

  const capeId = String(root.dataset.capeId);
  const cartUrl = root.dataset.cartUrl || '/cart';

  let active = false;
  let currentStep = 0;
  let previousFocus = null;
  let queued = Promise.resolve();

  const cartRoot = window.Shopify?.routes?.root || '/';

  const cartFetch = async () => {
    const r = await fetch(cartRoot + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!r.ok) {
      throw new Error('Cart fetch failed');
    }

    return r.json();
  };

  // =====================================================
  // ABRIR Y CERRAR POPUP
  // =====================================================

  function close() {
    if (currentStep === 2) {
      window.location.assign(cartUrl);
      return;
    }

    root.hidden = true;
    active = false;
    currentStep = 0;

    document.body.style.removeProperty('overflow');

    previousFocus?.focus?.();
  }

  function show(step) {
    currentStep = step;
    previousFocus = document.activeElement;

    first.hidden = step !== 1;
    protection.hidden = step !== 2;

    root.querySelector('.lpf-banner').hidden = step !== 1;

    root.hidden = false;
    active = true;

    document.body.style.overflow = 'hidden';

    panel.focus();
  }

  // =====================================================
  // COMPROBAR ESTADO DE LA CAPA
  // =====================================================

  function capeStatus(cart) {
    const items = cart.items || [];

    const cape = items.filter(i =>
      String(i.product_id) === capeId ||
      i.handle === 'capa-gasa'
    );

    const nonCapeTotal = items
      .filter(i => !cape.includes(i))
      .reduce(
        (s, i) =>
          s + Number(i.final_line_price ?? i.line_price ?? 0),
        0
      );

    const free =
      cape.length > 0 &&
      cape.every(i => Number(i.final_line_price) === 0);

    return {
      hasCape: cape.length > 0,
      qualifies: nonCapeTotal >= 10000,
      free
    };
  }

  // =====================================================
  // CONTENIDO DEL PRIMER POPUP
  // =====================================================

  function renderFirst(cart) {
    normalProducts.hidden = mode === 1;
    campaignProduct.hidden = mode !== 1;

    if (mode === 0) {
      kicker.textContent = t.normalKicker;
      title.innerHTML = t.normalTitle;
      title.classList.add('lpf-title--normal');
      desc.innerHTML = t.normalDesc;
      return;
    }

    title.classList.remove('lpf-title--normal');

    const s = capeStatus(cart);

    if (!s.hasCape) {
      kicker.textContent = s.qualifies
        ? t.giftKicker
        : t.giftNotYetKicker;

      title.innerHTML = s.qualifies
        ? t.giftTitle
        : t.giftNotYetTitle;

      desc.innerHTML = s.qualifies
        ? t.giftDesc
        : t.giftNotYetDesc;

      action.textContent = s.qualifies
        ? t.giftAction
        : t.continue;

      action.href = s.qualifies
        ? root.dataset.capeUrl
        : root.dataset.collectionUrl;

      action.hidden = !s.qualifies;

    } else if (s.qualifies && s.free) {
      action.hidden = false;

      kicker.textContent = t.giftInCartKicker;
      title.innerHTML = t.giftInCartTitle;
      desc.textContent = t.giftInCartDesc;

      action.textContent = t.giftInCartAction;
      action.href = cartUrl;

    } else {
      action.hidden = false;

      kicker.textContent = t.giftPendingKicker;
      title.innerHTML = t.giftPendingTitle;
      desc.textContent = t.giftPendingDesc;

      action.textContent = t.giftInCartAction;
      action.href = cartUrl;
    }
  }

  // =====================================================
  // SEGUNDO POPUP: PROTECCIÓN
  // =====================================================

  function showProtection() {
    show(2);
  }

  root.querySelector('#lpf-to-protection')
    .addEventListener('click', showProtection);

  root.querySelectorAll('[data-lpf-close]').forEach(el => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', e => {
    if (root.hidden) return;

    if (e.key === 'Escape') {
      close();
    }
  });

  // =====================================================
  // CONTROL DE APERTURA DEL CARRITO
  // =====================================================

  // Capturamos variant:add antes del listener del drawer.
  // Evitamos que Impact abra automáticamente el carrito.

  document.addEventListener('variant:add', e => {
    if (e.detail) {
      e.detail.blockCartDrawerOpening = true;
    }
  }, true);

  // =====================================================
  // DETECTAR PRODUCTO AÑADIDO
  // =====================================================

  // El popup solo aparece después de añadir un producto.
  // No se abre al cambiar cantidades ni al refrescar.

  document.addEventListener('cart:change', e => {
    if (e.detail?.baseEvent !== 'variant:add') return;

    const cart = e.detail?.cart;

    if (cart && Array.isArray(cart.items)) {
      renderFirst(cart);
      show(1);

    } else {
      queued = queued.then(async () => {
        const latestCart = await cartFetch();

        renderFirst(latestCart);
        show(1);

      }).catch(err => {
        console.error('[Lila popup]', err);
      });
    }
  });

})();
